import LegalPageLayout from '../components/layout/LegalPageLayout';

const SECTIONS = [
  {
    heading: '1. Acceptance of Terms',
    body: 'By creating an account or using PCredit, you agree to be bound by these Terms of Service. If you do not agree, please do not use the platform.',
  },
  {
    heading: '2. Eligibility',
    body: 'You must be at least 18 years old, a resident of Nigeria, and capable of entering into a binding contract to use PCredit\'s services. You must provide accurate and complete information during registration and verification.',
  },
  {
    heading: '3. Account Registration',
    body: 'You are responsible for maintaining the confidentiality of your login credentials and for all activity that occurs under your account. Notify us immediately of any unauthorized use.',
  },
  {
    heading: '4. Loan & Financial Services',
    body: 'Loan approvals, amounts, and interest rates are determined based on our credit assessment criteria and are not guaranteed. Repayment schedules, fees, and terms will be clearly presented before you accept any offer. Late or missed payments may affect your credit standing and Trust Score on the platform.',
  },
  {
    heading: '5. Fees & Charges',
    body: 'Any applicable fees — including processing fees, late payment penalties, and advance fees — will be disclosed to you before you confirm a transaction. We do not charge hidden fees.',
  },
  {
    heading: '6. User Responsibilities',
    body: 'You agree to use PCredit only for lawful purposes, to provide accurate information, and to repay any credit extended to you according to the agreed terms.',
  },
  {
    heading: '7. Prohibited Activities',
    body: 'You may not use the platform to commit fraud, launder money, impersonate another person, or interfere with the platform\'s normal operation. Violations may result in suspension or termination of your account and may be reported to relevant authorities.',
  },
  {
    heading: '8. Limitation of Liability',
    body: 'PCredit is provided on an "as available" basis. To the fullest extent permitted by law, we are not liable for indirect or consequential losses arising from your use of the platform.',
  },
  {
    heading: '9. Termination',
    body: 'We may suspend or terminate your account for violation of these Terms, suspected fraud, or as required by law. You may close your account at any time, subject to settlement of any outstanding obligations.',
  },
  {
    heading: '10. Governing Law',
    body: 'These Terms are governed by the laws of the Federal Republic of Nigeria.',
  },
  {
    heading: '11. Changes to These Terms',
    body: 'We may update these Terms from time to time. Continued use of PCredit after changes take effect constitutes acceptance of the updated Terms.',
  },
  {
    heading: '12. Contact Us',
    body: 'Questions about these Terms can be sent to support@mypcredit.com or through our Contact Us page.',
  },
];

export default function TermsOfService() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Terms of Service"
      updated="September 2026"
      sections={SECTIONS}
    />
  );
}
